/*
 * Copyright (c) 2026 Gabriele Bonora. Tutti i diritti riservati.
 *
 * Software proprietario. Nessuna licenza d'uso, copia, modifica o distribuzione
 * e' concessa in assenza di autorizzazione scritta del titolare dei diritti.
 * Vedere il file LICENSE nella radice del progetto.
 */

/*
 * I periodi del filtro sul conto: giorno, settimana, mese, anno, totale.
 * Tutto in date di calendario 'AAAA-MM-GG', estremi compresi, come le vuole
 * GET /api/interventi/:id/prezzo?dal=&al=. La settimana va da lunedi' a domenica.
 */

const pad = (n) => String(n).padStart(2, '0');

export function isoLocale(d) {
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

// Da 'AAAA-MM-GG' a Date a mezzogiorno locale: a mezzogiorno nessun cambio di ora
// legale sposta la data al giorno prima o dopo.
export function daIso(s) {
  const [y, m, g] = s.split('-').map(Number);
  return new Date(y, m - 1, g, 12);
}

export const UNITA = [
  { id: 'giorno',    label: 'Giorno' },
  { id: 'settimana', label: 'Settimana' },
  { id: 'mese',      label: 'Mese' },
  { id: 'anno',      label: 'Anno' },
  { id: 'totale',    label: 'Totale' },
];

// Il periodo dell'unita' che contiene `rif` (una Date). null per 'totale'.
export function periodoDi(unita, rif) {
  const y = rif.getFullYear();
  const m = rif.getMonth();
  if (unita === 'giorno') return { dal: isoLocale(rif), al: isoLocale(rif) };
  if (unita === 'settimana') {
    const lun = new Date(rif);
    lun.setDate(rif.getDate() - ((rif.getDay() + 6) % 7));
    const dom = new Date(lun);
    dom.setDate(lun.getDate() + 6);
    return { dal: isoLocale(lun), al: isoLocale(dom) };
  }
  if (unita === 'mese') return { dal: isoLocale(new Date(y, m, 1, 12)), al: isoLocale(new Date(y, m + 1, 0, 12)) };
  if (unita === 'anno') return { dal: `${y}-01-01`, al: `${y}-12-31` };
  return null;
}

// Sposta il riferimento di `passi` unita' (indietro con numeri negativi).
export function sposta(unita, rif, passi) {
  const d = new Date(rif);
  if (unita === 'giorno') d.setDate(d.getDate() + passi);
  else if (unita === 'settimana') d.setDate(d.getDate() + 7 * passi);
  else if (unita === 'mese') { d.setDate(1); d.setMonth(d.getMonth() + passi); }
  else if (unita === 'anno') d.setFullYear(d.getFullYear() + passi);
  return d;
}

const MESI = ['gennaio', 'febbraio', 'marzo', 'aprile', 'maggio', 'giugno',
  'luglio', 'agosto', 'settembre', 'ottobre', 'novembre', 'dicembre'];

export function fmtGiorno(s) {
  if (!s) return '—';
  const [y, m, g] = s.split('-');
  return `${g}/${m}/${y}`;
}

// L'etichetta leggibile del periodo: "marzo 2026", "settimana dal 02/03 al 08/03".
export function etichetta(unita, p) {
  if (!p) return "Tutto l'intervento";
  const d = daIso(p.dal);
  if (unita === 'giorno') return d.toLocaleDateString('it-IT', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' });
  if (unita === 'mese') return `${MESI[d.getMonth()]} ${d.getFullYear()}`;
  if (unita === 'anno') return String(d.getFullYear());
  if (unita === 'settimana') return `settimana dal ${fmtGiorno(p.dal)} al ${fmtGiorno(p.al)}`;
  return `dal ${fmtGiorno(p.dal)} al ${fmtGiorno(p.al)}`;
}

// 'AAAA-MM' o 'AAAA-MM-GG' della suddivisione delle ore, in parole.
export function fmtQuando(q) {
  if (q.length === 7) {
    const [y, m] = q.split('-');
    return `${MESI[Number(m) - 1]} ${y}`;
  }
  return daIso(q).toLocaleDateString('it-IT', { weekday: 'short', day: '2-digit', month: '2-digit' });
}
